import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withKeys as _withKeys, withDirectives as _withDirectives } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      _withDirectives(_createVNode("div", {
        ref: "modalRef",
        tabindex: "-1",
        class: "h-modal",
        onKeyup: _cache[3] || (_cache[3] = _withKeys(
//@ts-ignore
(...args) => (_ctx.onEscapePressed && _ctx.onEscapePressed(...args)), ["esc"]))
      }, [
        (_ctx.mask)
          ? (_openBlock(), _createBlock("div", {
              key: 0,
              class: "mask",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onMaskClicked && _ctx.onMaskClicked(...args)))
            }))
          : _createCommentVNode("", true),
        _createVNode(_Transition, {
          name: _ctx.transitionName,
          onAfterEnter: _ctx.afterEnter,
          onAfterLeave: _ctx.afterLeave
        }, {
          default: _withCtx(() => [
            (_ctx.visible)
              ? (_openBlock(), _createBlock("div", {
                  key: 0,
                  class: "h-modal__content",
                  style: _ctx.modalStyle
                }, [
                  (_ctx.showClose)
                    ? (_openBlock(), _createBlock("div", {
                        key: 0,
                        type: "close",
                        class: "close",
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
                      }))
                    : _createCommentVNode("", true),
                  _renderSlot(_ctx.$slots, "default")
                ], 4))
              : _createCommentVNode("", true)
          ]),
          _: 3
        }, 8, ["name", "onAfterEnter", "onAfterLeave"])
      ], 544), [
        [_vShow, _ctx.visible]
      ])
    ]),
    _: 1
  }))
}